export default class Loader {
  get CLASSES() {
    return {
      isLoaded: 'is-loaded',
    };
  }

  constructor() {
    this.$loader = document.querySelector('[data-loader]');
    if (!this.$loader) return;
    this.init();
  }

  init() {
    window.addEventListener('load', () => {
      document.documentElement.classList.add(this.CLASSES.isLoaded);
    });
  }
}
